import useResources from "./use-resources";

// Les modèles de bail sont en lecture seule : toute modification passe par une
// PR sur bail-templates/ (voir son README).
export default function useLeaseTemplates(options = {}) {
  const { withById = false } = options;
  const {
    resources: leaseTemplates,
    resourcesById: leaseTemplatesById,
    error,
    isLoading,
  } = useResources("lease-templates", {}, { withById });

  return {
    leaseTemplates,
    leaseTemplatesById,
    error,
    isLoading,
  };
}
